import { GlobalProvider } from "../global/context/global-context";
import { BaseLayout } from "./base-layout";
import { BaseLayoutProvider } from "./context/base-layout-context";

export function BaseLayoutFactory({ children }: { children: React.ReactNode }) {

    return (
        <BaseLayoutProvider>
            <BaseLayout>
                {children}
            </BaseLayout>
        </BaseLayoutProvider>
    );
}